/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateSSOImageStatusViewModel } from "../types/UpdateSSOImageStatusViewModel.ts";
import { ESSOImageStatusSchema } from "./ESSOImageStatusSchema.ts";

export const updateSSOImageStatusViewModelSchema = z.object({
  status: z
    .lazy(() => ESSOImageStatusSchema)
    .describe("1 = Draft | 2 = Publish | "),
}) as unknown as ToZod<UpdateSSOImageStatusViewModel>;
